import { render, staticRenderFns } from "./LatestBids.vue?vue&type=template&id=34ffe255&scoped=true&"
import script from "./LatestBids.vue?vue&type=script&lang=js&"
export * from "./LatestBids.vue?vue&type=script&lang=js&"
import style0 from "./LatestBids.vue?vue&type=style&index=0&id=34ffe255&scoped=true&lang=scss&"
import style1 from "./LatestBids.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ffe255",
  null
  
)

export default component.exports